import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import SubNavBarContainer from './SubNavBar/SubNavBarContainer';
import Hero from './Hero/Hero';
import PageHeader from './PageHeader/PageHeader';

const StudioWrapper = ({
  children,
  heroData,
  heroHeadline,
  posts = false,
  curatedButtons = [],
}) => {
  const router = useRouter();

  return (
    <>
      <SubNavBarContainer posts={posts} curatedButtons={curatedButtons} />
      {/* Only show the page header on the homepage. */}
      {router.pathname?.toLowerCase() === '/studio' && <PageHeader />}
      {heroData && <Hero heroData={heroData} heroHeadline={heroHeadline} />}
      {children}
    </>
  );
};

StudioWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  curatedButtons: PropTypes.array,
  heroData: PropTypes.any,
  heroHeadline: PropTypes.any,
  posts: PropTypes.array,
};

export default StudioWrapper;
